import { jsx as _jsx } from "react/jsx-runtime";
import { applyTokens } from "../../../utilities/applyTokens.js";
import { createLazyIcon } from "../../../utilities/createLazyIcon.js";
const breadcrumbs = (tokens) => {
    const { breadcrumbs } = tokens.component;
    const RightArrowIcon = createLazyIcon(() => import("@diligentcorp/atlas-react-icons/lens/ExpandRight.js"));
    return {
        MuiBreadcrumbs: {
            defaultProps: {
                separator: _jsx(RightArrowIcon, {}),
            },
            styleOverrides: {
                root: {
                    li: {
                        "p, a": Object.assign(Object.assign({ cursor: "pointer" }, applyTokens(breadcrumbs.link)), { ":hover": Object.assign({}, applyTokens(breadcrumbs.link.hover)) }),
                        "&:last-of-type": {
                            "p, a": Object.assign({}, applyTokens(breadcrumbs.link.last)),
                        },
                        "&:first-of-type": {
                            "p, a": Object.assign({}, applyTokens(breadcrumbs.link.first)),
                        },
                    },
                },
                separator: Object.assign({}, applyTokens(breadcrumbs.icon)),
            },
        },
    };
};
export default breadcrumbs;
//# sourceMappingURL=breadcrumbs.js.map